import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { M8DemoStackDTO } from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idUser: number;
};

export const getUserDemoStack = async (
  params: Params
): Promise<null | M8DemoStackDTO> => {
  const response = await customFetch(
    getM8AdminURL(`getUserDemoStack?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
